import { createContext, useContext } from 'react';
import { isNil } from 'lodash';
import { Logger } from 'utilities';
import { FundInvestmentsContextValue } from './FundInvestmentsContext.types';

const FUND_INVESTMENTS_CONTEXT_ERROR = 'useFundInvestmentContext must be used within a FundInvestmentsProvider';

const FundInvestmentsContext = createContext<FundInvestmentsContextValue | null>(null);
FundInvestmentsContext.displayName = 'FundInvestmentsContext';

export const useFundInvestmentContext = (): FundInvestmentsContextValue => {
  const context = useContext(FundInvestmentsContext);

  if (isNil(context)) {
    Logger.error(FUND_INVESTMENTS_CONTEXT_ERROR, null);
    throw new Error(FUND_INVESTMENTS_CONTEXT_ERROR);
  }

  return context;
};

export default FundInvestmentsContext;
